var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NumericResultBase',{attrs:{"value":_vm.result ? _vm.result.aggregate : null},scopedSlots:_vm._u([{key:"unit",fn:function(){return [_vm._v("\n    €\n  ")]},proxy:true}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }